// extracted by mini-css-extract-plugin
export var avatar = "_lf-3";
export var avatarContainer = "_lf-2";
export var avatarSpacer = "_lf-5";
export var avatarSpacerContainer = "_lf-4";
export var avatarStackContainer = "_lf-1";
export var bubble = "_lf-0";
export var remainderBubble = "_lf-6";